import './Price.scss';
import React from 'react';
import PriceCard from '../../components/price-components/PriceCard';
import Button from '../../components/button/Button';
import PriceDescriptions from '../../components/price-components/PriceDescriptions';
import PriceMob from '../../components/price-components/PriceMob';
import {mobOwn} from './mobData';
import { useInView } from 'react-intersection-observer';

function Price({t, handlerSelectModal}) {
  const{ ref,inView } = useInView({
    threshold:0,
  })
  const weExp = [`0 ${t('price_days')}`,`0 ${t('price_days')}`,'',`0 ${t('price_days')}`,'','6% or 12%','0 zl','0 zl','0 zl','-','0 zl','0 zl'];
  const own = [`min 30 ${t('price_days')}`,`7-10 ${t('price_days')}`,'',`From 3 to 6 ${t('price_month')}`,'','12/19% or 32%','1100 zl','500 zl','900-1700 zl',`300zl/${t('price_hour')}`,'600 zl','3600 zl'];
  const priceItemDescription =[t( "price_item_description1"),t( "price_item_description2"),t( "price_item_description3"),t( "price_item_description4"),t( "price_item_description5"),t( "price_item_description6"),t( "price_item_description7"),t( "price_item_description8"),t( "price_item_description9"),t( "price_item_description10")]
  const totalWeExp ='0 zl';
  const totalOwn ='7800 zl';
  const clas = 'activeCard'
  return (
    <div className="price-wrapper">
      <div ref={ref} className={`price-content-wrapper animation ${inView ? 'show-price': ""}`}>
        <div className="price-capture">
          {t("price_capture")}
        </div>
        <div className="price-columns-position">
          <PriceDescriptions data={priceItemDescription} total={t("price_total")}/>
          <PriceCard capture={'weExpert'} priceData={weExp} total={totalWeExp} classname={clas}/>
          <PriceCard capture={'Own Company'} priceData={own} total={totalOwn}/>
        </div>
        <div className="price-columns-position-mob" >
          <PriceMob t={t} capture1={'Own Company'} capture2={'weExpert'} botomTotalOwn ={'7800 zl'} botomTotalWeExp ={'450 zl'} mobOwn={mobOwn} total={t("price_total")}/>         
        </div>
        <div className="price-bottom">
          <Button text = {t("button_start_your_journey")}  handlerSelectModal={handlerSelectModal}/>
        </div>
      </div>
    </div>
  );
}

export default Price;